var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "issueCenter" }, [
    !_vm.$isFlag
      ? _c(
          "div",
          { staticClass: "left" },
          _vm._l(_vm.leftList, function(item, index) {
            return _c(
              "p",
              {
                key: index,
                class: index === _vm.currentIndex ? "active" : "",
                on: {
                  click: function($event) {
                    return _vm.titleClick(index, item.url)
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.getImg(item, index), alt: "" } }),
                _c("span", [_vm._v(_vm._s(item.name))])
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "right" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }